module.exports = __webpack_public_path__ + "static/media/gp_logo_lg.080cf922.png";